import cn from 'classnames';
import styles from './ProjectTag.module.css';

interface ProjectTagProps {
  className?: string;
  name: string;
  fontSize?: number;
}

const ProjectTag: React.FC<ProjectTagProps> = ({
  name,
  className = '',
  fontSize = 32,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <h1 className={styles.name}>
        <span
          className={cn({ [styles.fontsizing]: fontSize < 32 })}
          style={{
            fontSize: `${fontSize}px`,
            lineHeight: `${fontSize}px`,
          }}
        >
          {name}
        </span>
      </h1>
    </div>
  );
};

export default ProjectTag;
